export enum WIDGET_TYPE {
  RATING_RADIO = 'RatingRadioWidget',
  RATING = 'RatingWidget',
  ATTACH_FILE = 'AttachFileWidget'
}
